import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import MinhaArea from '../views/MinhaArea.vue';
import Detalhes from '../views/DetalhesPlano.vue';
import Sobre from '../views/Sobre.vue';
import Planos from '../views/Planos.vue';
import Pagamento from '../views/Pagamento.vue';
// import Noticia from './views/noticia'
import Duvidas from '../views/Duvidas.vue';
// import DetalheNoticia from './views/detalhe_noticia'
import Dependentes from '../views/Dependentes.vue';
import Contato from '../views/Contato.vue';
import Finalizado from '../views/Finalizado.vue';
import { GET } from '../services/api';
// import Opcoes from './views/opcoes_pagamento'
import NotFound from '../views/NotFound.vue';
import Cadastro from '../views/Cadastro.vue';
import VerificaEmail from '../views/VerificaEmail.vue';
import ConfirmaEmail from '../views/ConfirmaEmail.vue';
//import MeusDados from '../views/MeusDados.vue';


const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/login', name: 'Login', redirect: '/' },
  { path: '/minha-area', name: 'Area', component: MinhaArea },
  { path: '/sobre', name: 'Sobre', component: Sobre },
  { path: '/planos/:estado/:cidade', name: 'Planos', component: Planos },
  { path: '/finalizar-compra/pagamento', name: 'Pagamento', component: Pagamento },
  { path: '/uniodonto/:id_estado/:id_cidade/detalhes/planos/:id', name: 'Detalhes', component: Detalhes},
  // { path: '/noticia', name: 'Noticia', component: Noticia },
  { path: '/duvidas', name: 'Duvidas', component: Duvidas },
  // { path: '/detalhe-noticia/:id', name: 'DetalheNoticia', component: DetalheNoticia },
  { path: '/finalizar-compra/dependentes', name: 'Dependentes', component: Dependentes },
  { path: '/contato', name: 'Contato', component: Contato },
  // { path: '/finalizar-compra/opcoes-pagamento', name: 'Opcoes', component: Opcoes },
  { path: '/finalizar-compra/finalizado/:tipo/:protocolo', name: 'Finalizado', component: Finalizado },
  { path: '/finalizar-compra/cadastro', name: 'Cadastro', component: Cadastro},
  { path: '/verifica-email', name: 'VerificaEmail', component: VerificaEmail},
  { path: '/confirmar_email/:token', name: 'ConfirmaEmail', component: ConfirmaEmail},  
  //{ path: '/minha-area/meusdados', name: 'MeusDados', component: MeusDados},  
  { path: '/404', name: 'NotFound', component: NotFound},
  { path: "/:catchAll(.*)", redirect: '/404' }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// List of allowed routes when user has an active plan
const allowedRoutesWithPlan = ['/minha-area', '/logout']

// Function to check if user has an active plan via API
const checkUserPlanStatus = async (token) => {
  try {
    console.log('[API] Verificando status da assinatura...');
    console.log('[API] Token sendo usado:', token ? `${token.substring(0, 10)}...` : 'não informado');
    
    // Usando o padrão de chamada GET do projeto
    const response = await GET('verificar_assinatura_ativa', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    });
    console.log('[API] Resposta da verificação de assinatura:', response);
    
    if(response.assinatura){
      return true;
    }
    return false;
    
  } catch (error) {
    console.error('Erro ao verificar status da assinatura:', error);
    if (error.response) {
      console.error('Detalhes do erro:', {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      });
    }
    return false;
  }
};

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token_comprodonto');
  console.log('[Router] Navegando para:', to.path);
  console.log('[Router] Token presente:', !!token);
  
  // If no token, just continue
  if (!token) {
    console.log('[Router] Sem token, permitindo navegação');
    next();
    return;
  }
  
  // If already on allowed routes, continue
  if (allowedRoutesWithPlan.includes(to.path) || to.path.startsWith('/minha-area')) {
    console.log('[Router] Rota permitida, permitindo navegação');
    next();
    return;
  }
  
  try {
    console.log('[Router] Verificando status do plano...');
    // Check if user has an active plan
    const hasActivePlan = await checkUserPlanStatus(token);
    console.log('[Router] Status do plano ativo:', hasActivePlan);
    
    if (hasActivePlan) {
      if(hasActivePlan.assinatura.status === 'ativa'){
        console.log('[Router] Usuário tem plano ativo, redirecionando para /minha-area');
        // Redirect to Minha Área if user has an active plan
        next('/minha-area');
      }else{
        console.log('[Router] Usuário tem plano inativo, permitindo navegação');
        next();
      }
    } else {
      console.log('[Router] Usuário não tem plano ativo, permitindo navegação');
      next();
    }
  } catch (error) {
    console.error('Error in route guard:', error);
    next(); // Continue to the requested route in case of error
  }
});

export default router